// React
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Swiper
import "swiper/css";
import "swiper/css/navigation";

// Google Analytics
import { getAnalytics, logEvent } from "firebase/analytics";

// Components
import Navbar from "./features/navbar"
import Home from "./pages/home"
import Products from "./pages/products"
import About from "./pages/about"
import StoreLocator from './pages/storelocator';
import Socials from './features/socials';
import Footer from './features/footer';
import SingleProduct from "./components/single-product/singleproduct";
import Contact from "./pages/contact";
import Team from "./pages/team";
import ScrollToTop from "./features/scrolltotop";
import AgeVerification from "./features/ageverification";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase/firebase";
import VendorForm from "./pages/vendorform";
import Wholesale from "./pages/wholesale";
import PrivacyPolicy from "./pages/privacypolicy";


const App = () => {
    const [verified, setVerified] = useState(null)
    const [ mocktails, setMocktails] = useState(null)
    const [products, setProducts] = useState([])
    const [mockProd, setMockProd] = useState([])
    const [sortedProducts, setSortedProducts] = useState([])
    const [fanFavs, setFanFavs] = useState([])
    const [fanFavsMock, setFanFavsMock] = useState([])
    const [addEmail, setAddEmail] = useState(false)
    
    const analytics = getAnalytics();

    const queryProducts = async () => {
        try {
            const query = await getDocs(collection(db, "products"))
            const queryMock = await getDocs(collection(db, "mocktailsTest"))

            const data = query.docs.map(doc => ({...doc.data(), id: doc.id}))
            setProducts(data)

            const dataMock = queryMock.docs.map(doc => ({...doc.data(), id: doc.id}))
            setMockProd(dataMock)

            setFanFavs(data.filter(product => product.favorite === true).reverse())
            setFanFavsMock(dataMock.filter(product => product.favorite === true).reverse())
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        const ageData = window.localStorage.getItem("AGE_VERIFICATION")
        const productData = window.localStorage.getItem("PRODUCT_VERIFICATION")

        if (ageData === "true") {
            setVerified(true)
        } else {
            setVerified(false)
        }

        if (productData === "true") {
            setMocktails(true)
        } else {
            setMocktails(false)
        }


        queryProducts()
        logEvent(analytics, "website_traffic")
    }, [])

    useEffect(() => {
        window.localStorage.setItem("AGE_VERIFICATION", verified)
    }, [verified])

    useEffect(() => {
        window.localStorage.setItem("PRODUCT_VERIFICATION", mocktails)
    }, [mocktails])


    useEffect(() => {
        if (products.length !== 0) {
            setSortedProducts(products.sort((a,b) => a.name.localeCompare(b.name)))
        }
    },[products])



    return (
        <Router>
            {verified || mocktails ? <Navbar setMocktails={setMocktails} mocktails={mocktails} /> : null}
            <ScrollToTop />
            <Routes >
                    <Route element={
                                <AgeVerification 
                                    verified={verified}  
                                    setVerified={setVerified} 
                                    mocktails={mocktails}
                                    setMocktails={setMocktails}
                                />
                            }>
                        <Route  path="/" element={
                            <Home 
                                fanFavs={fanFavs} 
                                fanFavsMock={fanFavsMock}
                                setVerified={setVerified} 
                                setMocktails={setMocktails} 
                                mocktails={mocktails} 
                                verified={verified}
                            />} 
                        />
                        <Route  path="/products/:id"  element={
                            <SingleProduct 
                                products={mocktails ? mockProd : products} 
                                mockProd={mockProd}
                                setVerified={setVerified} 
                                mocktails={mocktails} 
                                verified={verified}
                            />} 
                        />
                        {sortedProducts.length !== 0 && <Route  path="/products"  element={
                            <Products 
                                sortedProducts={products} 
                                mockProd={mockProd}
                                setVerified={setVerified} 
                                setMocktails={setMocktails} 
                                mocktails={mocktails} 
                                verified={verified}
                                addEmail={addEmail}
                                setAddEmail={ setAddEmail} />}/>}
                        <Route  path="/about"  element={<About mocktails={mocktails }/>} />
                        <Route  path="/team"  element={<Team/>} />
                        <Route path="wholesale" element={<Wholesale />} />
                        <Route  path="/storelocator"  element={<StoreLocator/>} />
                        <Route  path="/contact"  element={<Contact />} />
                        <Route  path="/orderrequest"  element={<VendorForm />} />
                        <Route  path="/privacypolicy"  element={<PrivacyPolicy />} />
                        
                    </Route>
               

            </Routes>
            {verified || mocktails ? <Socials /> : null}
            {verified || mocktails ? <Footer addEmail={verified && addEmail} setAddEmail={verified && setAddEmail} /> : null}
        </Router>
    )
}

export default App
